import { defineMessages } from 'react-intl';

export default defineMessages({
    
   
    policies: {
        "id": 'portal.views.home-page-layout.Policies',
        "defaultMessage": 'Policies'
    },
    type: {
        "id": 'policy.common.directives.templates.policy-account-policy-summaries.type',
        "defaultMessage": 'Type'
    },
    statusActive: {
        "id": 'policy.common.directives.templates.policy-account-policy-summaries.Active',
        "defaultMessage": 'Active'
    },
    statusRenewed: {
        "id": 'policy.common.directives.templates.policy-account-policy-summaries.Renewed',
        "defaultMessage": 'Renewed'
    },
    status: {
        "id": 'policy.common.directives.templates.policy-account-policy-summaries.status',
        "defaultMessage": 'Status'
    },
    policy: {
        "id": 'policy.common.directives.templates.policy-account-policy-summaries.policy Details',
        "defaultMessage": 'Policy Details'
    },
    effective: {
        "id": 'policy.common.directives.templates.policy-account-policy-summaries.effective',
        "defaultMessage": 'Effective Period'
    },
    location:{
       
        "id": "policy.common.directives.templates.policy-account-policy-summaries.Location",
        "defaultMessage": "Location"
          
    },
    premium: {
        "id": 'policy.common.directives.templates.policy-account-policy-summaries.premium',
        "defaultMessage": 'Premium'
    },
    myQuickLinks: {
        "id": 'portal.views.home-page-layout.My Quick Links',
        "defaultMessage": 'My Quick Links'
    },
    printanIDCard: {
        "id": 'portal.views.home-page-layout.Print an ID Card',
        "defaultMessage": 'Print an ID Card'
    },
  
    setupAutomaticPayments: {
        "id": 'portal.views.home-page-layout.Setup Automatic Payments',
        "defaultMessage": 'Setup Automatic Payments'
    },
    changeMyPolicy: {
        "id": 'portal.views.home-page-layout.ChangeMyPolicy',
        "defaultMessage": 'Change My Policy'
    },
   
 
    policyDetailsAgent: {
        "id": 'policy.common.directives.templates.policy-account-policy-summaries.agent',
        "defaultMessage": 'Agent'
    },
    policyDetailsTel: {
        "id": 'policy.common.directives.templates.policy-account-policy-summaries.tel',
        "defaultMessage": 'T:'
    },
    policyDetailsIdCard: {
        "id": 'policy.common.directives.templates.policy-account-policy-summaries."id" card',
        "defaultMessage": 'ID Card'
    },
    policyDetailsFileClaim: {
        "id": 'policy.common.directives.templates.policy-account-policy-summaries.fileClaim',
        "defaultMessage": 'File a Claim'
    },
    myBalanceTileCurrent: {
        "id": 'portal.directives.templates.billing-summary-tiles.Current',
        "defaultMessage": 'Current'
    },
    policyNotShowing: {
        "id": 'portal.views.home-page-layout.Do you have a policy with us but it is not showing?',
        "defaultMessage": 'Do you have a policy with us but it is not showing?'
    },
    addPolicy: {
        "id": 'portal.views.home-page-layout.Add Policy',
        "defaultMessage": 'Add Policy'
    },
    // WorkersCompLine:{
    //     id: 'policy.common.directives.templates.policy-account-policy-summaries.Workers Compensation',
    //     "defaultMessage": 'Workers Compensation'
    // },
    // PersonalAutoLine:{
    //     id: 'policy.common.directives.templates.policy-account-policy-summaries.Personal Auto',
    //     "defaultMessage": 'Personal Auto'
    // }
});